import { render, staticRenderFns } from "./VirtualList.vue?vue&type=template&id=446a5ede"
import script from "./VirtualList.vue?vue&type=script&lang=ts"
export * from "./VirtualList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports